import { Box } from "../../box";
import { forwardRef } from "react";
import { cssModule, mergeProps, normalizeSize, slot } from "../../shared";
import { useResponsiveValue, useStyleProps } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerHeading(props) {
  const [styleProps] = useStyleProps("heading");
  const {
    as = DefaultElement,
    children,
    forwardedRef,
    size,
    ...rest
  } = mergeProps(props, styleProps);
  const sizeValue = useResponsiveValue(size);
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-heading", normalizeSize(sizeValue)),
      ref: forwardedRef
    }),
    children: children
  });
}
InnerHeading.defaultElement = DefaultElement;
export const Heading = slot("heading", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerHeading, { ...props,
  forwardedRef: ref
})));

/////////////
function createHeading(as) {
  return slot("heading", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerHeading, { ...props,
    as: as,
    forwardedRef: ref
  })));
}

export const H1 = createHeading("h1");
export const H2 = createHeading("h2");
export const H3 = createHeading("h3");
export const H4 = createHeading("h4");
export const H5 = createHeading("h5");
export const H6 = createHeading("h6");